<template>
  <ais-instant-search  :search-client="searchClient" :index-name="algoliaIndex" :routing="routing" v-cloak>

    <ais-configure :attributesToRetrieve="attributesToRetrieve"  :disjunctive-facets-refinements.camel="initialSettings" :hits-per-page.camel="hitsPerPage" :analytics="analytics" :get-ranking-info.camel="getRankingInfo" :distinct="true" :filters.camel="filters"></ais-configure>
    <ais-search-box>
      <div class="mb-2 mb-md-4 input-group input-group-seamless" slot-scope="{ currentRefinement, isSearchStalled, refine }">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="material-icons ml-1 text-primary" style="font-size: 20px;">search</i></div>
        </div>
        <input :value="currentRefinement" @input="refine($event.currentTarget.value)" type="search" style="font-size:15px;padding-left:2.6rem;" class="form-control py-3 text-dark" placeholder="Search for something..." >
      </div>
    </ais-search-box>
    <slot></slot>
  </ais-instant-search>
</template>

<script>
// imports
import algoliasearch from 'algoliasearch/lite';

export default {
  name: 'InstantSearch',
  data() {
    const app = this;
    return {
      init: false,
      attributesToRetrieve: ['objectID', 'name', 'mimeType', 'mimeTypeLabel', 'webViewLink', 'owner', 'lastModifiedBy', 'modifiedTimestamp'],
      algoliaClient: algoliasearch(
        'DXAHZPLPP0',
        app.algoliaApiKey,
        ),
      searchClient: {
        search(requests) {
          const shouldSearch = requests.some(({ params: { query, facetFilters } }) => query !== '' || facetFilters);
          if (shouldSearch || app.allowBlank) {
            return app.algoliaClient.search(requests);
          }
          return Promise.resolve({
            results: [{ hits: [] }],
          });
        },
      },
    };
  },
  created() {
    const displaySettings = this.$store.state.searchSettings.attributesToDisplay;
    this.attributesToRetrieve = this.attributesToRetrieve.concat([displaySettings.description])
    for (var i = 0; i < displaySettings.details.length; i++) {
      this.attributesToRetrieve.push(displaySettings.details[i].attribute);
      if(displaySettings.details[i]['sub-attribute']) {
        this.attributesToRetrieve.push(displaySettings.details[i]['sub-attribute'].value);
      }
    }
  },
  props: {

    initialSettings: {
      type: Object,
      default: null,
    },
    algoliaIndex: {
      type: String,
      default: '',
    },
    algoliaApiKey: {
      type: String,
    },

    hitsPerPage: {
      type: Number,
      default: 10,
    },
    query: {
      type: String,
      default: '',
    },
    getRankingInfo: {
      type: Boolean,
      default: true,
    },
    allowBlank: {
      type: Boolean,
      default: false,
    },
    analytics: {
      type: Boolean,
      default: false,
    },
    routing: {
      type: Object,
      default: null,
    },

    filters: {
      type: String,
      default: 'NOT permissionLevel:limited AND trashed:false',
    },
  },
};

</script>
